// hooks/useApplications.ts
import { useEffect, useState, useCallback } from 'react';
import { onSnapshot, collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';
import { Application } from '../types/application';

export const useApplications = () => {
  const [applications, setApplications] = useState<Application[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchApplications = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const q = query(collection(db, 'applications'), orderBy('created_at', 'desc'));
      const snapshot = await getDocs(q);
      const apps = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as Application[];
      
      setApplications(apps);
    } catch (err) {
      console.error('애플리케이션 데이터 로딩 실패:', err);
      setError('데이터를 불러오는 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const q = query(collection(db, 'applications'), orderBy('created_at', 'desc'));
    const unsubscribe = onSnapshot(
      q, 
      (snapshot) => {
        try {
          const apps = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          })) as Application[];

          setApplications(apps);
          setLoading(false);
          setError(null);
        } catch (err) {
          console.error('실시간 데이터 파싱 오류:', err);
          setError('데이터 처리 중 오류가 발생했습니다.');
          setLoading(false);
        }
      },
      (err) => {
        console.error('Firestore 구독 오류:', err);
        setError('실시간 데이터 연결에 실패했습니다.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { 
    applications, 
    loading, 
    error, 
    refetch: fetchApplications 
  };
};
